import type { IncludeExcludeState } from '@pulsepointinc/bi-components';

export const getExpressionListFromString = (expression: string) => {
  return expression.split(',').map((alias) => alias.replace(/^-/, '').trim());
};

export const getModeFromFilterState = (filterState: IncludeExcludeState): 'block' | 'check' | undefined => {
  const active = Object.values(filterState);
  if (active.some((i) => i.check)) return 'check';
  if (active.some((i) => i.block)) return 'block';
  return undefined;
};

export const getIconType = (expressionType?: string) =>
  expressionType === 'block' ? 'ExcludeDefault' : 'IncludeDefault';
